import { Predictor } from '../../interfaces/predictors';

const getFirstOpenPredictor = (openPredictors: Predictor[]) => {
  return openPredictors.length > 0
    ? openPredictors.reduce((prev, next) => {
        return prev.closeTime <= next.closeTime ? prev : next;
      })
    : undefined;
};

const lastClosedPredictor = (closedPredictors: Predictor[]) => {
  return closedPredictors.length > 0
    ? closedPredictors.reduce((prev, next) => {
        return prev.closeTime >= next.closeTime ? prev : next;
      })
    : undefined;
};

type getPredictorPriorityProps = {
  lastClosed?: Predictor;
  firstOpen?: Predictor;
  secondOpen?: Predictor;
};
const getPredictorPriority = ({ lastClosed, firstOpen, secondOpen }: getPredictorPriorityProps) => {
  const showPriority: Predictor[] = [];
  const now = Date.now();
  if (lastClosed && lastClosed.displayEndTime > now) showPriority.push(lastClosed);
  if (firstOpen) showPriority.push(firstOpen);
  if (secondOpen) showPriority.push(secondOpen);
  return showPriority;
};

export const findPredictorsToUse = (
  predictors: Predictor[],
  predictorId?: number,
): {
  active?: Predictor;
  next?: Predictor;
} => {
  if (predictors.length === 0) return { active: undefined, next: undefined };
  const now = Date.now();

  const openPredictors = predictors.filter(
    (predictor) => now >= predictor.openTime && now < predictor.closeTime && predictor.status === 'prematch',
  );

  const closedPredictors = predictors.filter((predictor) => now > predictor.closeTime);

  const firstOpen = getFirstOpenPredictor(openPredictors);
  const secondOpen = getFirstOpenPredictor(
    openPredictors.filter((predictor) => predictor.predictorId !== firstOpen?.predictorId),
  );

  const lastClosed = lastClosedPredictor(closedPredictors);

  const showPriority = getPredictorPriority({ firstOpen, secondOpen, lastClosed });

  if (predictorId) {
    const selectedPredictor = predictors.find((predictor) => predictor.predictorId === predictorId);
    return { active: selectedPredictor, next: showPriority[0] };
  }

  // if we have nothing to show but still got predictors we can use one that is not open to show prizes on the start screen
  if (showPriority.length === 0) return { active: undefined, next: predictors[0] };
  return { active: showPriority[0], next: showPriority[1] };
};
